class TreeListModule {
    constructor() {
        this.init();
    }

    init() {
        this.toggleMenu();
        this.applyCatalogsToCategories();
    }

    applyCatalogsToCategories() {
        $('.single-catalog').each((i, catalog) => {
            var catalogID = $(catalog).attr('data-category');
            var catalogName = $(catalog).attr('data-catalog');
            var catalogLink = $(catalog).attr('data-link');

            console.log(catalogID);

            $('li.cat-item').each((i, li) => {
                if($(li).hasClass(`cat-item-${catalogID}`)) {
                    //$(li).append(catalog);
                    $(li).append(`<div class="catalogs catalogs-hidden"><a href="${catalogLink}">${catalogName}</a></div>`)
                    $(li).addClass('current-cat-ancestor');
                };
            });
        });
    }

    toggleMenu() {
        $('li.cat-item a').on('click', (e) => {
            var $this = $(e.target);
            
            console.log($this.next('.children'));

            if($this.next('.children').length > 0) {
                e.preventDefault();
                $this.next('.children').toggleClass('show');
            }
            else {

            }

            if($this.next('.catalogs').length > 0) {
                e.preventDefault();
                $this.parent().find('.catalogs').toggleClass('catalogs-hidden');
            }
            else {
                
            }
        });

        setTimeout(() => {
            $('.categories > ul > li.current-cat-ancestor').find('> div.catalogs-hidden').removeClass('catalogs-hidden');
        }, 125);
    }
}

export default TreeListModule;